import React from 'react';

import { FullPageEditorSideEffects } from './FullPageEditorSideEffects.tsx';
import type { FullPageEditorSideEffectsProps } from './FullPageEditorSideEffects.tsx';

/**
 * Renders the FullPageEditorSideEffects component to isolate side effects
 * from the main FullPageEditorComponent render cycle.
 */
export const ConditionalSideEffectsComponent: React.FC<FullPageEditorSideEffectsProps> = (
	props,
) => {
	return <FullPageEditorSideEffects {...props} />;
};
